import MdmLink from '~/components/atoms/MdmLink.vue';
import '@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
export default {
  name: 'GlobalSelection',
  components: {
    MdmLink
  },
  props: {
    url: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    title: {
      type: Object,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    cta: {
      type: String,
      default: ''
    }
  }
};